(() => {
  document.querySelectorAll('[data-dd-manual-feed]').forEach((feed) => {
    const track = feed.querySelector('[data-dd-feed-track]');
    const prev = feed.querySelector('[data-dd-feed-prev]');
    const next = feed.querySelector('[data-dd-feed-next]');

    if (!track) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector('.dd-feed-card');
      const gap = parseFloat(window.getComputedStyle(track).columnGap || '0');
      const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;

      track.scrollBy({
        left: amount * direction,
        behavior: 'smooth',
      });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
  });
})();
